<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wmAlHw/tc-custom/9780226150338.jpg?1722571967864" alt="This image is the cover for the book Mehinaku"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mehinaku
      </h1>
      <p class="bookDescription body article font2">
        <p>Thomas Gregor sees the Mehinaku Indians of central Brazil as performers of roles, engaged in an ongoing improvisational drama of community life. The layout of the village and the architecture of the houses make the community a natural theater in the round, rendering the villagers' actions highly visible and audible. Lacking privacy, the Mehinaku have become masters of stagecraft and impression management, enthusiastically publicizing their good citizenship while ingeniously covering up such embarrassments as extramarital affairs and theft.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Gregor
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?621d58e8